export const NUMBER_REGEX = /^[0-9\b]+$/;
export const e2p = (text: string) => text?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
export const e2a = (text: string) => text?.replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
export const p2e = (text: string) => text?.replace(/[۰-۹]/g, d => ('۰۱۲۳۴۵۶۷۸۹' as any).indexOf(d));
export const a2e = (text: string) => text?.replace(/[٠-٩]/g, d => ('٠١٢٣٤٥٦٧٨٩' as any).indexOf(d));
export const p2a = (text: string) => text?.replace(/[۰-۹]/g, d => '٠١٢٣٤٥٦٧٨٩'['۰۱۲۳۴۵۶۷۸۹'.indexOf(d)]);
export const a2p = (text: string) => text?.replace(/[٠-٩]/g, d => '۰۱۲۳۴۵۶۷۸۹'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);
export const toEnNumber = (text: string) => a2e(p2e(text));
export const isEmptyOrNumber = (text: string, trim?: boolean) => {
  if (trim) {
    text = text.trim();
  }
  return text === '' || NUMBER_REGEX.test(text);
};

export const insertAt = function(original: string, index: number, value: string) {
  if (index > 0) {
    return original.substring(0, index) + value + original.substring(index);
  }
  return value + original;
};

const strings = {
  e2p,
  e2a,
  p2e,
  a2e,
  p2a,
  a2p,
  insertAt
};

export default strings;
